var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleParkingLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F38C3856-43B5-4F3A-9C8F-00C47BCB63A6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOTEL-DETAILS-1",
    transform: "translate(-222.000000, -2004.000000)",
    fill: "#7CBEEA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(222.000000, 1729.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle-parking-light",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5,20 C37.5,10.3350169 29.6649831,2.5 20,2.5 C10.3350169,2.5 2.5,10.3350169 2.5,20 C2.5,29.6649831 10.3350169,37.5 20,37.5 C29.6649831,37.5 37.5,29.6649831 37.5,20 Z M0,20 C0,8.954305 8.954305,0 20,0 C31.045695,0 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 C8.954305,40 0,31.045695 0,20 Z M16.25,22.5 L22.5,22.5 C25.2578125,22.5 27.5,20.2578125 27.5,17.5 C27.5,14.7421875 25.2578125,12.5 22.5,12.5 L16.25,12.5 L16.25,22.5 Z M22.5,25 L16.25,25 L16.25,28.75 C16.25,29.4375 15.6875,30 15,30 C14.3125,30 13.75,29.4375 13.75,28.75 L13.75,23.75 L13.75,11.875 C13.75,10.8359375 14.5859375,10 15.625,10 L22.5,10 C26.640625,10 30,13.359375 30,17.5 C30,21.640625 26.640625,25 22.5,25 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleParkingLight);
export default __webpack_public_path__ + "static/media/circle-parking-light.ba62663278c5c2fa7507eb3093c41d14.svg";
export { ForwardRef as ReactComponent };